import React from "react";
import { BsCameraVideo } from "react-icons/bs";
import { BiPodcast } from "react-icons/bi";
import { HiOutlineDocumentText } from "react-icons/hi";
import { IoPlay, IoImagesOutline, IoChatbubblesOutline } from "react-icons/io5";
import { FaFile } from "react-icons/fa6";
import { PiCardsThreeFill, PiHeadphonesFill } from "react-icons/pi";

interface ContentTypeIconProps {
  type: string;
  className?: string;
}

const ContentTypeIcon: React.FC<ContentTypeIconProps> = ({
  type,
  className,
}) => {
  const iconClassName =
    className === "white"
      ? "w-[2rem] h-[1.7rem] text-white"
      : "w-[2rem] h-[1.7rem] text-black";

  switch (type?.toLowerCase()) {
    // New format types
    case "videos":
    case "video":
      return <IoPlay className={iconClassName} />;
    case "documents":
    case "document":
      return (
        <FaFile
          className={
            className === "white"
              ? "w-[2rem] h-[1.3rem] text-white"
              : "w-[2rem] h-[1.3rem] text-black"
          }
        />
      );
    case "podcasts":
    case "podcast":
      return <PiHeadphonesFill className={iconClassName} />;
    case "slides":
    case "slide":
      return <PiCardsThreeFill className={iconClassName} />;
    
    // Existing content type cases for backward compatibility
    case "clinical education":
      return (
        <FaFile
          className={
            className === "white"
              ? "w-[2rem] h-[1.3rem] text-white"
              : "w-[2rem] h-[1.3rem] text-black"
          }
        />
      );
    case "guidelines & protocols":
      return (
        <FaFile
          className={
            className === "white"
              ? "w-[2rem] h-[1.3rem] text-white"
              : "w-[2rem] h-[1.3rem] text-black"
          }
        />
      );
    case "medical news":
      return <PiCardsThreeFill className={iconClassName} />;
    case "patient case studies":
      return (
        <FaFile
          className={
            className === "white"
              ? "w-[2rem] h-[1.3rem] text-white"
              : "w-[2rem] h-[1.3rem] text-black"
          }
        />
      );
    case "patient information material":
      return <PiCardsThreeFill className={iconClassName} />;
    case "procedures & surgeries":
      return <IoPlay className={iconClassName} />;
    case "recent clinical advances":
      return (
        <FaFile
          className={
            className === "white"
              ? "w-[2rem] h-[1.3rem] text-white"
              : "w-[2rem] h-[1.3rem] text-black"
          }
        />
      );
    // Fallback cases for backward compatibility
    case "webinars & panel discussions":
      return <IoPlay className={iconClassName} />;
    case "podcasts":
      return <PiHeadphonesFill className={iconClassName} />;
    case "editorials & research case studies":
      return (
        <FaFile
          className={
            className === "white"
              ? "w-[2rem] h-[1.3rem] text-white"
              : "w-[2rem] h-[1.3rem] text-black"
          }
        />
      );
    case "infographics":
    case "medical slide library":
      return <PiCardsThreeFill className={iconClassName} />;
    case "expert opinions":
      return <IoPlay className={iconClassName} />;
    default:
      return <IoPlay className={iconClassName} />;
  }
};

export default ContentTypeIcon;
